/** User-facing API error messages for auth flows (login, signup, password reset). */

const BY_CODE = {
  INVALID_CREDENTIALS: {
    login: 'Email or password is incorrect. Please check your credentials and try again.',
    'send-code':
      'Email or password is incorrect. A login verification code can only be sent after your password is verified.',
    preview: 'Email or password is incorrect. Please check your email and password.',
    default: 'Email or password is incorrect. Please check and try again.',
  },
  CAPTCHA_REQUIRED: 'Please complete the slider verification before continuing.',
  CAPTCHA_INVALID: 'Slider verification expired. Please slide again to verify.',
  CAPTCHA_FAILED: 'Slider verification failed. Please try again.',
  LOGIN_CODE_REQUIRED: 'Please enter the 4-digit login verification code sent to your email.',
  LOGIN_CODE_INVALID:
    'The login verification code is incorrect or has expired. Click "Send code" to request a new one.',
  ACCOUNT_LOCKED: null,
  ACCOUNT_PENDING_REVIEW:
    'Your account is pending admin approval. You will be notified by email once approved.',
  ACCOUNT_INACTIVE:
    'Your account is not active. Please contact support if you believe this is a mistake.',
  ACCOUNT_DELETED: 'This account is no longer available.',
  ADMIN_IP_DENIED: 'Admin login is not allowed from your current IP address.',
  GEO_BLOCKED: 'Access from your region is not allowed.',
  EMAIL_DOMAIN_NOT_ALLOWED:
    'This email domain is not on the allowed corporate domain list. Please use your company work email.',
  VERIFICATION_CODE_INVALID:
    'The verification code is incorrect or has expired. Please request a new code.',
  EMAIL_SEND_FAILED:
    'We could not send the verification email. Please try again later or contact support.',
  EMAIL_REQUIRED: 'Please enter your email address.',
  PASSWORD_REQUIRED: 'Please enter your password.',
}

const STATUS_FALLBACKS = {
  429: 'Too many requests. Please wait a moment and try again.',
  500: 'Something went wrong on our side. Please try again in a moment.',
  503: 'This service is temporarily unavailable. Please try again later.',
}

/**
 * @param {unknown} error - axios error
 * @param {'login'|'send-code'|'preview'|'signup'|'reset'|string} [context]
 * @param {string} [fallback]
 */
export function getAuthErrorMessage(error, context = 'default', fallback = 'Something went wrong. Please try again.') {
  const data = error?.response?.data || {}
  const code = data.code
  const serverMessage = typeof data.message === 'string' ? data.message.trim() : ''

  if (code && Object.prototype.hasOwnProperty.call(BY_CODE, code)) {
    const mapped = BY_CODE[code]
    if (mapped === null && serverMessage) return serverMessage
    if (typeof mapped === 'string') return mapped
    if (mapped && typeof mapped === 'object') {
      return mapped[context] || mapped.default || serverMessage || fallback
    }
  }

  if (serverMessage) return serverMessage

  const status = error?.response?.status
  if (status && STATUS_FALLBACKS[status]) return STATUS_FALLBACKS[status]

  if (!error?.response) {
    return 'Network error. Please check your connection and try again.'
  }

  return fallback
}
